const faCircleHalfStroke = {
  prefix: 'fal',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, 'adjust'], 'f042', 'M272 479.4l0-446.9C388.2 40.8 480 137.7 480 256S388.2 471.2 272 479.4zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z'],
};
export default faCircleHalfStroke;
